<form class="row" (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="col-12">
    <div class="form-group">
      <label for="profile">Perfil: </label> <span class="required-mark"> * </span>
      <ng-select
        bindLabel="nombre"
        [readonly]="!isUserCanales"
        [items]="profiles$ | async"
        labelForId="profile"
        formControlName="profile"
      ></ng-select>
    </div>
  </div>

  <div class="col-12">
    <div class="form-group">
      <label for="role">Roles: </label><span class="required-mark"> * </span>
      <ng-select
        [items]="roles$ | async"
        bindLabel="nombre"
        [multiple]="true"
        labelForId="role"
        formControlName="roles"
      ></ng-select>
    </div>
  </div>

  <div class="col-12" *ngIf="showField(AccessField.Company)">
    <uni-form-field>
      <uni-label>Empresa: </uni-label>
      <input uniInput [readonly]="!isUserCanales" formControlName="company" />
    </uni-form-field>
  </div>

  <div class="col-12" *ngIf="showField(AccessField.Company)">
    <div class="form-group">
      <label for="empresaUnitId">Empresa Unit: </label>
      <ng-select [items]="companyAllies$ | async" bindLabel="nombre" labelForId="id" formControlName="empresaUnitId"></ng-select>
    </div>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.ProfileIdentification)">
    <uni-form-field>
      <uni-label>Identificación Perfil: </uni-label>
      <input uniInput formControlName="identificationProfile" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.UserCode)">
    <uni-form-field>
      <uni-label>Código de Usuario: </uni-label>
      <input uniInput formControlName="userCode" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.IntermediaryCode)">
    <uni-form-field>
      <uni-label>Código de Intermediario: </uni-label>
      <input uniInput [readonly]="!isUserCanales" formControlName="intermediaryCode" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.IntermediaryCodeUnit)">
    <uni-form-field>
      <uni-label>Código de Intermediario Unit: </uni-label>
      <input uniInput [readonly]="!isUserCanales" formControlName="intermediaryCodeUnit" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.ClientCode)">
    <uni-form-field>
      <uni-label>Código de Cliente: </uni-label>
      <input uniInput formControlName="clientCode" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.ClientCodeUnit)">
    <uni-form-field>
      <uni-label>Código de Cliente Unit: </uni-label>
      <input uniInput formControlName="clientCodeUnit" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.FiduciaryRnc)">
    <uni-form-field>
      <uni-label>RNC Empresa: </uni-label>
      <input uniInput [readonly]="!isUserCanales" formControlName="fiduciaryRnc" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.OfficeCode)">
    <uni-form-field>
      <uni-label>Código de Sucursal: </uni-label>
      <input uniInput formControlName="officeCode" />
    </uni-form-field>
  </div>

  <div class="col-md-6" *ngIf="showField(AccessField.HealthProviderCode)">
    <uni-form-field>
      <uni-label>Código de Prestador: </uni-label>
      <input uniInput [readonly]="!isUserCanales" formControlName="healthProviderCode" />
    </uni-form-field>
  </div>

  <div class="col-md-6">
    <uni-form-field>
      <uni-label>Correo Electrónico:</uni-label>
      <input uniInput formControlName="email" type="email" />
    </uni-form-field>
  </div>

  <div class="col-md-12" *ngIf="!isEditing && isUserCanales">
    <div
      *ngIf="
        (profileName?.nombre === ProfileName.HealthProvider ||
          profileName?.nombre === ProfileName.IntermediarioARS ||
          profileName?.nombre === ProfileName.IntermediarioSeguros) &&
        !isUserCanalesControl
      "
      class="form-group"
    >
      <label for="admin">Es Usuario Administrador: </label>
      <ui-switch
        name="admin"
        color="#009BC9"
        switchColor="#FFFFFF"
        defaultBgColor="#D5D5D5"
        formControlName="isUserAdmin"
        class="ml-5"
      ></ui-switch>
    </div>
    <div *ngIf="!isUserAdminControl" class="form-group">
      <label for="canales">Es Usuario de Canales: </label>
      <ui-switch
        name="canales"
        color="#009BC9"
        switchColor="#FFFFFF"
        defaultBgColor="#D5D5D5"
        formControlName="isUserCanales"
        class="ml-5"
      ></ui-switch>
    </div>
  </div>

  <div class="col-md-12 d-flex justify-content-between pt-3">
    <button type="button" uniStepperPrevious uni-button iconReverse="true" fill="outline" icon="chevron-left">Regresar</button>
    <button type="submit" uni-button [disabled]="form.invalid">{{ isEditing ? "Editar" : "Crear" }} Usuario</button>
  </div>
</form>
